import React from 'react';
import { connect } from 'react-redux';
import { deleteShareAnswerKey } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteShareAnswerKey,
};

function ModalDeleteShareAnswerKey({ deleteShareAnswerKey, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const id = item?.id;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteShareAnswerKey({ auth, history, id });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda ingin berhenti membagikan kunci jawaban tes{' '}
        <span className='has-text-danger has-text-weight-semibold'>{`${item.title}`}</span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteShareAnswerKey);
